import React from 'react';
import { Slide } from 'react-awesome-reveal';

//images
import cx5Hero from '../css/images/mazda-page/hero.jpg';
import roadImg from '../css/images/mazda-page/road.jpg';
import col1Img from '../css/images/mazda-page/col-1.jpg';
import col2Img from '../css/images/mazda-page/col-2.jpg';
import googleImg from '../css/images/mazda-page/google.jpg';
import appImg from '../css/images/mazda-page/apple-car.jpg';
import appleCarImg from '../css/images/mazda-page/google.jpg';
import speedImg from '../css/images/mazda-page/speed.jpg';
import gal1Img from '../css/images/mazda-page/gal-1.jpg';
import gal2Img from '../css/images/mazda-page/gal-2.jpg';
import cocheImg from '../css/images/mazda-page/tech-img.jpg';

const MazdaCX5Page = () => {
	return (
		<div className="mazda-cx5-page">
			{/* HERO */}
			<section className="cx5-hero">
				<img src={cx5Hero} alt="Mazda CX-5" />
			</section>

			{/* DESCUBRE */}
			<section className="cx5-descubre">
				<div className="cx5-descubre__inner">
					<Slide direction="up">
						<p className="cx5-descubre__label">EL MEJOR VIAJE NUNCA TERMINA</p>
						<h1 className="cx5-descubre__title">
							DESCUBRE EL NUEVO MAZDA CX-5
						</h1>
					</Slide>
				
						<div className="cx5-stats">
							<div className="cx5-stats__item">
								<span className="cx5-stats__value">
									583 <small>L</small>
								</span>
								<span className="cx5-stats__label">DE VOLUMEN DE CARGA</span>
							</div>
							<div className="cx5-stats__item">
								<span className="cx5-stats__value">
									<small className="cx5-stats__prefix">HASTA </small>15,6"
								</span>
								<span className="cx5-stats__label">DE PANTALLA CENTRAL</span>
							</div>
							<div className="cx5-stats__item">
								<span className="cx5-stats__value">
									+100 <small>APPS</small>
								</span>
								<span className="cx5-stats__label">GOOGLE INTEGRADO™</span>
							</div>
							<div className="cx5-stats__item">
								<span className="cx5-stats__value">
									2000 <small>KG</small>
								</span>
								<span className="cx5-stats__label">CAPACIDAD DE REMOLQUE*</span>
							</div>
						</div>
			
				</div>
			</section>

			{/* MÁS INTELIGENTE */}
			<section className="cx5-text-section w-image">
				<div className="cx5-text-section__inner">
					<h2>MÁS INTELIGENTE, SEGURO Y PREPARADO</h2>
					<p>
						El nuevo Mazda CX-5 sigue fiel a nuestra tradición de fiabilidad y
						versatilidad. Diseñado para acompañarte en tu día a día, incorpora
						la tecnología más avanzada para ayudarte en la conducción y ofrece
						una experiencia interior para una mayor versatilidad. El Mazda CX-5
						de nueva generación —con alma arraigada en la tradición, pero
						diseñado para la vida familiar de hoy.
					</p>
				</div>

				<div className="cx5-text-section__inner">
					<img src={roadImg} alt="Mazda CX-5 en carretera" />
				</div>

				<div className="cx5-text-section__inner">
					<h2>DISEÑADO PARA DESTACAR</h2>
					<p>
						Con una estética de inspiración japonesa, la silueta dinámica del
						nuevo Mazda CX-5 te hechiza con sus proporciones equilibradas, un
						frontal impresionante y una personalidad propia. Fiel a nuestros
						principios Mazda de diseño Kodo, el resultado es un vehículo moderno
						y versátil que transmite una sólida confianza en cada momento.
					</p>
				</div>
			</section>

			{/* GALERÍA MOSAICO */}
			<section className="cx5-gallery">
				<div className="cx5-gallery__left">
					<img src={gal1Img} alt="Mazda CX-5 exterior" />
				</div>

				<div className="cx5-gallery__right">
					<img src={gal2Img} alt="Mazda CX-5 paisaje" />{' '}
				</div>
			</section>

			{/* INTERIOR */}
			<section className="cx5-text-section">
				<div className="cx5-text-section__inner">
					<Slide direction="up" triggerOnce={true}>
						<h2>UN INTERIOR DE ELABORACIÓN ARTESANAL</h2>
					</Slide>

					<p>
						El interior del nuevo Mazda CX-5 transforma tu día a día con una
						combinación perfecta de confort, espacio y versatilidad. El amplio
						espacio para hombros y piernas en todos los asientos crea un
						ambiente íntimo, mientras que los materiales nobles y el maletero
						flexible están listos para acompañarte en cualquier aventura. La
						gran pantalla central y la luz ambiente crean un entorno elegante y
						sereno.
					</p>
				</div>
			</section>

			{/* CONFORT + MALETERO */}
			<section className="cx5-two-col">
				<div className="cx5-two-col__item">
					<img src={col1Img} alt="Confort interior" />
					<div className="cx5-two-col__text">
						<Slide direction="up">
							<h3>CONFORT PARA TODOS</h3>
						</Slide>

						<p>
							Diseñado para adaptarse a tus necesidades individuales y favorecer
							la comodidad. Sus fundas tienen suficiente espacio para la cabeza,
							los hombros y las piernas, además de saber cómo estar cuando
							llevas la familia completa o cuando quieres disfrutar de un
							momento solo con tu pareja. La respuesta siempre es la misma.
						</p>
					</div>
				</div>
				<div className="cx5-two-col__item">
					<img src={col2Img} alt="Espacio de maletero" />
					<div className="cx5-two-col__text">
						<Slide direction="up">
							<h3>ESPACIO DE MALETERO DISPONIBLE</h3>
						</Slide>

						<p>
							Ya sea para transportar equipaje o para cualquier aventura, el
							maletero se adapta con total facilidad. Es fácil abrir y cerrar el
							maletero hasta hacer práctico el mayor aprovechamiento posible del
							espacio disponible. Todo esto a mano y bien organizado.
						</p>
					</div>
				</div>
			</section>

			{/* TECNOLOGÍA AVANZADA */}
			<section className="cx5-tech">
				<div className="cx5-tech__header">
					<h2>TECNOLOGÍA AVANZADA</h2>
					<p>
						El nuevo Mazda CX-5 pone a tu alcance una conectividad intuitiva y
						tecnología fiable que te acompaña en cada trayecto. Ya sea para
						tener toda la información, moverte con facilidad o tener tu mundo
						digital siempre contigo, cada función está diseñada para que todo
						fluya de forma sencilla y natural.
					</p>
				</div>
				<div className="cx5-tech__grid">
					<div className="cx5-tech__card">
						<div className="cx5-tech__card-text">
							<Slide direction="up">
								<h3>GOOGLE INTEGRADO™</h3>
							</Slide>
							<p>
								Con Google integrado™, cada trayecto se vuelve más útil,
								conectado y personalizado, como si llevaras un copiloto contigo.
								Google Gemini™, Google Maps™ y Google Play™ están listos para
								ayudarte: pídele a Gemini que suba la calefacción, busque una
								dirección, haga una llamada o controle los dispositivos
								inteligentes compatibles de tu hogar.
							</p>
						</div>
						<div className="cx5-tech__card-image">
							<img src={googleImg} alt="Google Integrado" />
						</div>
					</div>
					<div className="cx5-tech__card">
						<div className="cx5-tech__card-text">
							<Slide direction="up">
								<h3>MYMAZDA APP</h3>
							</Slide>
							<p>
								Con MyMazda App tendrás conexión directa con tu vehículo, estés
								donde estés. Consulta su estado, localízalo fácilmente o envía
								destinos al sistema de navegación desde tu móvil. Todo está
								diseñado para simplificar tu día a día y mantener las funciones
								esenciales siempre a tu alcance.
							</p>
						</div>
						<div className="cx5-tech__card-image">
							<img src={appImg} alt="MyMazda App" />
						</div>
					</div>
					<div className="cx5-tech__card">
						<div className="cx5-tech__card-text">
							<Slide direction="up">
								<h3>APPLE CARPLAY® Y ANDROID AUTO™</h3>
							</Slide>
							<p>
								No pierdas la conexión allá donde vayas con Apple CarPlay® y
								Android Auto™. El nuevo Mazda CX-5 te permite acceder fácilmente
								a tus apps favoritas sin distracciones al volante.
							</p>
						</div>
						<div className="cx5-tech__card-image">
							<img src={appleCarImg} alt="Apple CarPlay y Android Auto" />
						</div>
					</div>
					<div className="cx5-tech__card">
						<div className="cx5-tech__card-text">
							<Slide direction="up">
								<h3>HEAD UP DISPLAY</h3>
							</Slide>
							<p>
								El Head-up Display proyecta información importante, como la
								velocidad o las indicaciones de navegación, directamente en el
								parabrisas, dentro de tu campo de visión. Así se reducen las
								distracciones y puedes mantener la atención en la carretera. Es
								una función discreta que marca una gran diferencia en cada
								trayecto.
							</p>
						</div>
						<div className="cx5-tech__card-image">
							<img src={speedImg} alt="Head Up Display" />
						</div>
					</div>
				</div>
			</section>

			{/* MOTOR */}
			<section className="cx5-motor">
				<div className="cx5-motor__inner">
					<div className="cx5-motor__text">
						<h2>MOTOR E-SKYACTIV G DE 2,5 L MEJORADO</h2>
						<p>
							El nuevo Mazda CX-5 está equipado con un renovado motor de
							gasolina de 2,5 litros con tecnología híbrida ligera, que combina
							eficiencia y rendimiento a la vez que cumple con la normativa de
							emisiones Euro 6e. Disponible con cambio automático en 2WD y 4WD,
							se adapta fácilmente a tu estilo de conducción. Y con una
							capacidad de remolque con freno de hasta 2000 kg, está preparado
							para todo lo que te propongas.
						</p>
						<p className="cx5-motor__footnote">
							* Capacidad de remolque con frenos
						</p>
					</div>
					<div className="cx5-motor__image">
						<img src={cocheImg} alt="Motor Mazda CX-5" />
					</div>
				</div>
			</section>

			{/* LEGALES */}
			<section className="cx5-legal">
				<div className="cx5-legal__inner">
					<p>* Capacidad de remolque con frenos</p>
					<p>
						** Google Assistant, Google Maps y Google Play estarán disponibles
						durante un período de tres (3) años, contando a partir de la fecha
						de primera matriculación del nuevo vehículo. Para utilizar otras
						aplicaciones descargadas de Google Play Store, es necesario conectar
						al vehículo un smartphone que tenga un sistema operativo compatible
						con iOS o Android y una tarjeta SIM con un paquete de datos activo
						de un proveedor de telefonía. Pueden producirse gastos adicionales.
						La disponibilidad de las aplicaciones puede variar según el país.
					</p>
					<p>
						Durante el período gratuito y una vez finalizado, también podrás
						usar Google Assistant, Google Maps y Google Play si conectas a tu
						vehículo un smartphone con un sistema operativo compatible con iOS o
						Android y una tarjeta SIM con un paquete de datos activo de un
						proveedor de telefonía. Pueden producirse gastos adicionales. Ten en
						cuenta lo siguiente: para utilizar Google Assistant, Google Maps y
						Google Play en tu vehículo, es necesario aceptar los términos de
						servicio de Google.
					</p>
					<p>
						Google, Android, Google Play y Google Maps son marcas de Google LLC.
						La disponibilidad puede variar según el dispositivo, el país y el
						idioma.
					</p>
					<p>
						*** Google, Gemini, Google Play y Google Maps son marcas comerciales
						de Google LLC. Se necesita conexión a internet y un sistema
						operativo compatible. La disponibilidad podría variar según el
						dispositivo, el país y el idioma.
					</p>
					<p>2 &nbsp; Solo disponible en versiones Exclusive-Line y Homura.</p>
					<p>
						1 &nbsp; Hasta 10 años de protección. Garantía Mazda integral de 6
						años o 150.000 km (lo que antes suceda), válido para vehículos
						matriculados a partir del 1 de septiembre de 2022 y hasta 4 años a
						través del programa de Calidad Garantizada, consulte condiciones
						aquí.
					</p>
					<p>
						Apple CarPlay® y Android Auto™ son marcas registradas en Estados
						Unidos y otros países. Apple, el logotipo de Apple, Apple CarPlay®,
						Apple Watch, App Store y iPad son marcas registradas de Apple Inc.
					</p>
					<p>
						Mazda CX-5 Híbrido Ligero: Consumo de combustible combinado WLTP
						(l/100km): 7-7,5 l/100km, emisiones de CO₂ (g/km): WLTP: 157-169
						g/km
					</p>
					<p>
						Valores de consumos y emisiones de CO2 medidos según procedimiento
						de homologación WLTP según la exigencia del Reglamento (UE)
						2017/1151 y Reglamento (CE) 715/2007.
					</p>
					<p>
						Puede que el modelo mostrado no se corresponda con las
						especificaciones del mercado español. Los colores y algunos
						elementos del exterior e interior pueden variar en pantalla con
						respecto al modelo real. Es posible que algunos de los equipamientos
						mostrados formen parte de versiones y/o packs opcionales y pueden
						estar sujetos a disponibilidad.
					</p>
				</div>
			</section>
		</div>
	);
};

export default MazdaCX5Page;
